import React from 'react';
import { CoreAsyncButton, CoreTable } from '@amzn/dots-core-ui';
import Column from '@amzn/meridian/column';
import Heading from '@amzn/meridian/heading';
import Row from '@amzn/meridian/row';
import { LMSLab, LMSLocation, useClient, useInfiniteGetAll } from '$/api';
import { LabAddButton, LabColumnDefinitions } from '$/features/Labs';

type LocationLabsTableProps = {
  lmslocation?: LMSLocation;
};

export const LocationLabsTable = ({
  lmslocation,
}: LocationLabsTableProps): JSX.Element => {
  const { lmslabs } = useClient();
  const locationId = lmslocation?.id;
  const { data, allData, isLoading, hasNextPage, fetchNextPage } =
    useInfiniteGetAll(lmslabs.resourceKey, lmslabs.getAll, { locationId });
  return (
    <Column spacing="small">
      <Heading level={3}>
        <Row widths="fill">
          Labs
          <Row alignmentHorizontal="right">
            <LabAddButton lmslocation={lmslocation} />
          </Row>
        </Row>
      </Heading>
      <CoreTable
        fixHeaderRows
        isLoading={isLoading && !data}
        columnDefinitions={LabColumnDefinitions}
        getItemId={(item: LMSLab) => item.id}
        items={allData}
      />
      <Row alignmentHorizontal="center">
        <CoreAsyncButton
          disabled={!hasNextPage}
          type="tertiary"
          onClick={async (): Promise<void> => {
            await fetchNextPage();
          }}
        >
          Load More
        </CoreAsyncButton>
      </Row>
    </Column>
  );
};

LocationLabsTable.defaultProps = {
  lmslocation: '',
};
